import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionPlayerXpHighScoresNameRequest, actionPlayerXpHighScoresPositionRequest, TypeActionRanking, } from "../actionRanking";
export var epicPlayerXpRanking = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.PlayerXpRankingRequest), switchMap(function (action) {
        return action.nameSearch
            ? of(actionPlayerXpHighScoresNameRequest(action.nameSearch))
            : of(actionPlayerXpHighScoresPositionRequest(action.position || 1));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicPlayerXpRanking.ts
// module id = 2120
// module chunks = 3